module.exports = __webpack_public_path__ + "img/logo-se.eb64d7f.png";